module.exports = __webpack_public_path__ + "img/parttwo_pic4.de41ff23.png";